import { ButtonTertiary } from "components/Atoms/Button";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import AreYouSureModal from "components/modals/AreYouSureModal";
import React from "react";

interface Props {
  canApprove?: boolean;
  approveEndpoint?: () => Promise<any>;
  sublabel?: string;
}

const NotValidatedRow = (props: Props) => {
  const [isApproving, setIsApproving] = React.useState(false);

  return <>
    <div className="flex gap card-floating-bg radius padding">
      <PhosphorWarning iconSize="large" />
      <div className="grow1">
        <div>{RESX.Planning.NotYetChecked}</div>
        <div className="text-sublabel">{props.sublabel}</div>
      </div>
      {props.canApprove && <div>
        <ButtonTertiary onClick={() => { setIsApproving(true); }} label={RESX.Buttons.Approve} />
      </div>}
    </div>
    {isApproving && <AreYouSureModal
      title={RESX.Buttons.Approve}
      yesButtonLabel={RESX.Buttons.Approve}
      yesButtonColor="green"
      onClose={() => { setIsApproving(false); }}
      onYes={async () => props.approveEndpoint().then(() => { window.location.reload(); })}
    />}
  </>;
};

export default NotValidatedRow;